import { render, staticRenderFns } from "./Moneyorder.vue?vue&type=template&id=5194b9b4&scoped=true"
import script from "./Moneyorder.vue?vue&type=script&lang=js"
export * from "./Moneyorder.vue?vue&type=script&lang=js"
import style0 from "./Moneyorder.vue?vue&type=style&index=0&id=5194b9b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194b9b4",
  null
  
)

export default component.exports